import { PageContent } from '@/components/layout/page-content'
import { PageHeader } from '@/components/layout/page-header'
import { PageLayout } from '@/components/layout/page-layout'
import { TableInfo } from '@/components/tables/table'
import type { Request } from '@/types/requests/request'
import { useGeneralRequests } from './hooks/use-general-requests-hook'

export const GeneralRequestsPage = () => {
  const {
    states: { data, isLoading },
    actions: { createTable }
  } = useGeneralRequests()

  const tableConfig = createTable(data?.data)

  return (
    <PageLayout isLoading={isLoading} loadingText="Carregando Solicitações">
      <PageHeader title="Menu De Solicitações" breadcrumb />
      <PageContent>
        <TableInfo<Request>
          paginationData={data?.pagination}
          withFilters={true}
          tableConfig={tableConfig}
          isLoading={isLoading}
        />
      </PageContent>
    </PageLayout>
  )
}
